import React, { useEffect, useState, useRef } from "react";
import "../OrderTable.css";
import convertToIST from "../../../../../services/istTime";
import RejectModal from "../../../components/RejectModal";
import api from "../../../../../services/api";
import { useToast } from "../../../../../mesageToast/ToastContainer";
import { useDispatch } from "react-redux";
import { updateStaus } from "../../../../../redux/Slice/OrderSlice";
import UpdatePopup from "./UpdateModal";
import MoreDetails from "../../../components/MoreDetails";

function OrdersTableInprogressTakeaway({ items, refresh }) {
  const [showData, setShowData] = useState([]);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [popupVisible, setPopupVisible] = useState(null);
  const [moreDetails, setMoreDetails] = useState(null);
  const [updatePopupVisible, setUpdatePopupVisible] = useState(null);
  const [copied, setCopied] = useState(false);
  const [status, setStatus] = useState(null);
  const [delayTime, setDelayTime] = useState(null); // Track delay time
  const [initialStatus, setInitialStatus] = useState(""); // Track initial status when modal opens
  const [hoveredRow, setHoveredRow] = useState(null);
  const [openMoreDetails, setOpenMoreDetails] = useState(false);
  const addToast = useToast();
  const dispatch = useDispatch();

  const popupRef = useRef(null);

  const handleDeleteItem = (id) => {
    setSelectedOrder(id);
    setRejectModalOpen(true);
  };
  const handleRejectModalClose = () => {
    setRejectModalOpen(false);
  };
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000); // Hide message after 2 seconds
  };

  useEffect(() => {
    setShowData(
      items.filter((order) => {
        return (
          order.user.orderStatus !== "Cancelled" &&
          order.user.orderStatus !== "Completed" &&
          order.user.orderStatus !== "No-Show" &&
          order.user.orderStatus !== "Order Placed"
        );
      })
    );
  }, [items]);

  const togglePopup = (id, event) => {
    event.stopPropagation();
    setPopupVisible(popupVisible === id ? null : id);
  };
  const toggleUpdatePopup = (id, event, order) => {
    event.stopPropagation();
    if (updatePopupVisible === id) {
      setUpdatePopupVisible(null);
      setStatus(null);
      setDelayTime(null);
      setInitialStatus("");
    } else {
      const currentStatus = order.user?.orderStatus || "";
      setUpdatePopupVisible(id);
      setStatus(currentStatus);
      setInitialStatus(currentStatus);
      setDelayTime(null);
    }
  };

  const handleClickOutside = (event) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      !event.target.classList.contains("more-options")
    ) {
      setPopupVisible(null);
    }
  };

  useEffect(() => {
    if (popupVisible !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupVisible]);

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
  };

  const handleUpdateStatus = (orderId) => {
    if (!status) {
      addToast("Error", "Please select a status.", "error");
      return;
    }
    if (status === "Delayed" && !delayTime) {
      addToast("Error", "Please select delay time.", "error");
      return;
    }
    
    const requestData = { status };
    if (status === "Delayed" && delayTime) {
      requestData.delayTime = delayTime;
    }
    
    api
      .patch(`/restaurant-management/orders/UpdateStatus/${orderId}`, requestData)
      .then((res) => {
        addToast("Order Updated", "Status has been Updated.", "success");
        dispatch(updateStaus({ id: orderId, status }));
        
        // Force immediate refresh for delayed orders
        if (status === "Delayed") {
          setTimeout(() => {
            if (refresh) refresh();
          }, 100);
        } else {
          if (refresh) refresh();
        }
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || "Failed to update order status.";
        addToast("Error", errorMessage, "error");
        console.log(error);
      });
    setStatus(null);
    setDelayTime(null);
    setUpdatePopupVisible(null);
  };
  const handleCloseUpdatedPopup = () => {
    setUpdatePopupVisible(null);
    setStatus(null);
    setDelayTime(null);
    setInitialStatus("");
  };

  const handleOpenMoreDetails = (id) => {
    setHoveredRow(null);
    setPopupVisible(null); 
    setMoreDetails(id);
    setOpenMoreDetails(true);
  };

  const handleOnCloseMoreDetails = () => {
    setOpenMoreDetails(false);
  };

  return (
    <>
      <table className="inProgressTable">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Name</th>
            <th>Order Time</th>
            <th>Pickup Time</th>
            <th>Status</th>
            <th>Items</th>
            <th>Total Amt.</th>
            <th>Payment</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {showData.length === 0 ? (
            <tr style={{ backgroundColor: 'transparent' }}>
              <td colSpan="9" style={{ textAlign: 'center', backgroundColor: 'transparent' }}>No Order Is In Progress</td>
            </tr>
          ) : (
            showData.map((item, index) => {
              const isLastRow = index === showData.length - 1;
              return (
                <tr
                  key={item.id}
                  onMouseEnter={() => setHoveredRow(item.id)} // Set hovered row
                  onMouseLeave={() => setHoveredRow(null)} // Clear hovered row
                >
                  <td>
                    <p>{item.id}</p>
                  </td>
                  <td>{item.user.name}</td>
                  <td>{convertToIST(item.createdTime).time}</td>
                  <td>{item.user.pickupTime}</td>
                  <td>
                    <div 
                      className={`${item.user.orderStatus}`}
                      style={item.user.orderStatus === "Check In" ? {
                        backgroundColor: '#b2e0f1',
                        color: '#157499',
                        padding: '6px',
                        borderRadius: '12px',
                        fontSize: '14px',
                        textAlign: 'center'
                      } : {}}
                    >
                      {item.user.orderStatus === "Check In" ? "Arrived" : item.user.orderStatus}
                    </div>
                  </td>
                  <td>{item.user.items.length}</td>
                  <td>₹ {item.user.subTotal}</td>
                  <td>Paid</td>
                  <td>
                    <button
                      className="mark-unavailable"
                      onClick={(event) => toggleUpdatePopup(item.id, event, item)}
                    >
                      Update
                    </button>
                    <button
                      className="delete"
                      onClick={() => handleDeleteItem(item)}
                      disabled={item.user.orderStatus === "Ready" || item.user.orderStatus === "Check In" || item.user.orderStatus === "No-Show"}
                      style={(item.user.orderStatus === "Ready" || item.user.orderStatus === "Check In" || item.user.orderStatus === "No-Show") ? {
                        color: '#999',
                        borderColor: '#999',
                        cursor: 'not-allowed',
                        backgroundColor: '#f2f2f2',
                      } : {}}
                    >
                      Cancel
                    </button>
                    {hoveredRow === item.id &&
                      updatePopupVisible === null &&
                      popupVisible === null && (
                        <div
                          className={`hover-popup ${
                            isLastRow ? "hover-popup-top" : ""
                          }`}
                        >
                          {item.user.items.map((itm, index) => (
                            <div key={index}>
                              <h5>{itm.name}</h5>
                              <p>
                                ₹{itm.price}.00 | Qty:{" "}
                                {itm.quantity < 10
                                  ? `0${itm.quantity}`
                                  : itm.quantity}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}

                    <button
                      className="more-options"
                      onClick={(event) => togglePopup(item.id, event)}
                    >
                      ⋮
                    </button>

                    {popupVisible === item.id && ( // Show popup based on item.id
                      <div
                        className="popup"
                        style={{
                          left: "65px",
                          ...(isLastRow ? { top: "-70px" } : {}),
                        }}
                        ref={popupRef}
                      >
                        <button onClick={() => console.log("Call Customer")}>
                          Call Customer
                        </button>
                        <button onClick={() => handleOpenMoreDetails(item)}>
                          More Details
                        </button>
                      </div>
                    )}
                    {updatePopupVisible === item.id && (
                      <UpdatePopup
                        item={item}
                        status={status}
                        setStatus={setStatus}
                        delayTime={delayTime}
                        setDelayTime={setDelayTime}
                        handleStatusChange={handleStatusChange}
                        handleUpdateStatus={handleUpdateStatus}
                        handleClosePopup={handleCloseUpdatedPopup}
                        copyToClipboard={copyToClipboard}
                        copied={copied}
                        initialStatus={initialStatus}
                      />
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      {rejectModalOpen && (
        <RejectModal
          isOpen={rejectModalOpen}
          order={selectedOrder}
          onClose={handleRejectModalClose}
          refresh={refresh}
        />
      )}
      {openMoreDetails && (
        <MoreDetails
          order={moreDetails}
          isOpen={openMoreDetails}
          onClose={handleOnCloseMoreDetails}
        />
      )}
    </>
  );
}

export default OrdersTableInprogressTakeaway;


